var splitString = function splitString(str, delimiter) {
  var result = [];
  str.split(delimiter).forEach(function (str) {
    result.push(str);
    result.push(delimiter);
  });
  result.pop();
  return result;
};

var splitArray = function splitArray(ary, delimiter) {
  var result = [];
  ary.forEach(function (part) {
    var subRes = [];
    part.split(delimiter).forEach(function (str) {
      subRes.push(str);
      subRes.push(delimiter);
    });
    subRes.pop();
    subRes = subRes.filter(function (str) {
      if (str) {
        return str;
      }

      return undefined;
    });
    result = result.concat(subRes);
  });
  return result;
};

var superSplit = function superSplit(splittable, delimiters) {
  if (delimiters.length === 0) {
    return splittable;
  }

  if (typeof splittable === 'string') {
    var delimiter = delimiters[delimiters.length - 1];
    var split = splitString(splittable, delimiter);
    return superSplit(split, delimiters.slice(0, -1));
  }

  if (Array.isArray(splittable)) {
    var _delimiter = delimiters[delimiters.length - 1];

    var _split = splitArray(splittable, _delimiter);

    return superSplit(_split, delimiters.slice(0, -1));
  }

  return false;
};

module.exports = superSplit;